/**
 * regionTags value behind each nested remote reach ring (finland = tagged FI, europe = tagged EU,
 * world = the whole hub). Kept free of server imports: the hero links and the SRP's
 * unfiltered-hub check use it in the browser.
 */
export const REACH_REGION_TAGS = { finland: 'FI', europe: 'EU' } as const;
